import './loader.css';

export default function LoaderMonitoring() {
    return (
        <div className="monitoring__loader monitoring__servergroup">
            <div className="loader-1 monitoring__loader-title"></div>
            <div className="monitoring__servers monitoring__loader-servers">
                <div className="loader-1 monitoring__loader-server"></div>
                <div className="loader-1 monitoring__loader-server"></div>
            </div>
        </div>
    )
}